export const SET_ALL_TRANSLATIONS = 'SET_ALL_TRANSLATIONS';

export function setAllTranslations(translations) {
    return {
        type: SET_ALL_TRANSLATIONS,
        payload: translations
    }
}